// extracted by mini-css-extract-plugin
var _1 = "downloadApp_container__XyS3i";
export { _1 as "container" }
